import styled from 'styled-components/';
import AppCSS from '../../../../utils/styled';
import { Calendar } from 'react-big-calendar';

export const Components = {
  Container: styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    background-color: ${AppCSS.colors.utility.headerBar.background};
  `,
  Calendar: styled(Calendar)<{ isDayView: boolean }>`
    height: 100%;
    overflow-y: auto;
    width: 100%;

    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    & .rbc-time-content {
      border-top: 1px solid ${AppCSS.colors.greys.light};
    }
    & .rbc-time-view .rbc-time-content > * + * > * {
      ${({ isDayView }) => isDayView && 'border-left: none'};
    }
    & .rbc-timeslot-group {
      min-height: 84px;
      background-color: transparent;
    }
    & .rbc-time-header.rbc-overflowing {
      border-right: none;
    }
    & .rbc-month-view {
      border: none;
    }
    & .rbc-month-header .rbc-header {
      ${AppCSS.fonts.label10Regular};
      color: ${AppCSS.colors.blues.dark};
      padding-top: 8px;
      padding-bottom: 2px;
      padding-right: 8px;
      display: flex;
      justify-content: flex-end;
    }
    & .rbc-month-row .rbc-date-cell {
      padding: 8px 8px 6px 8px;
    }
    & .rbc-month-row .rbc-day-bg {
      background-color: transparent;
    }
    & .rbc-month-row .rbc-row-content {
      background-color: transparent;
    }
    & .rbc-day-slot .rbc-time-slot {
      border-top: none;
      background-color: transparent;
    }
    & .rbc-show-more {
      background-color: transparent;
      ${AppCSS.fonts.label10Regular};
      color: ${AppCSS.colors.blues.dark};
      text-decoration: none;
      padding: 6px 8px;
    }
    & .rbc-event {
      height: 22px;
      background-color: transparent;
      &:focus {
        outline: none;
      }
    }
    & .rbc-selected {
      background-color: transparent !important;
    }
    & .rbc-events-container {
      margin-right: 0;
    }
    & .rbc-label {
      text-align: right;
    }
  `,
  DateCellDay: styled.div`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
    padding-top: 4px;
    padding-right: 8px;
  `,
  AppointmentsSection: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 24px 0 4px 0;
  `,
  ApointmentMonthText: styled.span`
    ${AppCSS.fonts.label12Bold};
    margin-bottom: 4px;
    text-align: center;
  `,
  AppointmentDay: styled.div`
    width: 42px;
    min-height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${AppCSS.fonts.h3};
    ${AppCSS.radiuses.rounded};
    color: ${AppCSS.colors.blue};
  `,
  AppointmentsText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.middle};
    margin-left: 8px;
  `,
  WeekDayTextContainer: styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  WeekHeaderDayText: styled.div<{ isCurrentDay?: boolean }>`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    margin-bottom: 4px;
  `,
  WeekHeaderDayNumber: styled.div<{ isCurrentDay?: boolean }>`
    width: 42px;
    min-height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${AppCSS.fonts.h3};
    margin-bottom: 4px;
    ${(p) => p?.isCurrentDay && `color: ${AppCSS.colors.blue};`};
    ${AppCSS.radiuses.rounded};
  `,
  CollapseButton: styled.div<{ isMiniCalendarShown: boolean }>`
    position: absolute;
    top: 8px;
    left: -20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    ${AppCSS.radiuses.forHeight(40)};
    background-color: ${({ isMiniCalendarShown }) => (isMiniCalendarShown ? AppCSS.colors.white : AppCSS.colors.blue)};
    overflow: hidden;
    ${AppCSS.boxShadows.floatingButton};
  `,
  CollapseButtonIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  `,
};
